import './location-selector.scss'

import { ReactiveVue } from '@skinsoft/reactive-vue';
import { Modal } from 'bootstrap-vue';
import Component from 'vue-class-component';
import { LocationSelector } from '../location-selector';

@Component({
    components: {
        sLocationSelector: LocationSelector
    },
    props: [''],
    template: require('./location-selector-popup.html')
})
export class LocationSelectorPopup extends ReactiveVue {

    public $refs: {
        modal: Modal
    }

    private location: any = null;

    public open() {
        this.$refs.modal.show();
    }

    public onLocationSelected(locationChangeEvent) {
        this.location = locationChangeEvent.location;
    }

    public validateLocation() {
        this.$emit("location-validated", { location: this.location });
        this.$refs.modal.hide();
    }

}